import { Component, input } from '@angular/core';
import { DropzoneComponent } from '@ngx-dropzone/cdk';

@Component({
  selector: 'mtjr-dropzone',
  standalone: true,
  template: `
    <div [class]="'custom-dropzone ' + borderRadiusClass()">
      <ng-content select="[fileInput]"></ng-content>
    </div>
  `,
})
export class VxDropzoneComponent extends DropzoneComponent {
  borderRadiusClass = input<string>('!rounded-xl');
}
